import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    ReportingDepartment, AddressMainCategory,
} from 'app/enums/label.enums'
import {
    Damage,
} from '../Damages.types'

const getDamageCreateFields = (getAllowedValues): DTOCardFormField<keyof Damage>[] => {
    return [{
        title: 'Damage Details',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'container',
                        labelKey: 'Damages.serialNumber',
                        componentName: 'ContainerSelector',
                        required: true,
                    },
                    {
                        name: 'reportingServiceCenter',
                        labelKey: 'Damages.reportingServiceCenter',
                        componentName: 'LocationObjectSelector',
                        filterAddressMainCategory: AddressMainCategory.SERVICECENTER,
                    },
                    {
                        name: 'damageType',
                        componentName: 'DamageTypeSelector',
                        required: true,
                        labelKey: 'Damages.damageType',
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'reportedOn',
                        labelKey: 'Damages.reportedOn',
                        componentName: 'DateTimeSelect',
                        required: true,
                    },
                    {
                        name: 'damageComment',
                        labelKey: 'Damages.damageComment',
                        componentName: 'LongText',
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'reportedBy',
                        labelKey: 'Damages.reportedBy',
                        componentName: 'ContactObjectSelector',
                        required: true,
                    },
                    {
                        name: 'reportingDepartment',
                        labelKey: 'Damages.reportingDepartment',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ReportingDepartment),
                        required: true,
                        useDropdown: true,
                    },
                ],
            },
            {
                id: 'column4',
                fields: [{
                    name: 'damageAttachments',
                    labelKey: 'Damages.damageAttachment',
                    componentName: 'AttachmentsObjectSelector',
                }],
            },
        ],
    }]
}

export default getDamageCreateFields
